import React from 'react'
import PropTypes from 'prop-types'

const Spinner = ({ text = 'Loading', className = 'flex-col text-c-blue', size = 'h-8 w-8' }) => {
  return (
    <div className="spinner-border text-secondary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}
Spinner.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
}

export default Spinner
